import { useState, useEffect } from "react";
import { Tab, TabList, TabPanel, Tabs as Tb } from "react-tabs";
import SocialReachesSingleItem from "./SocialReachesSingleItem";
import axios from "../../../../libs/axios";
import AddScreenshots from "./AddScreenshots";
import useCurrentUser from "../../../../hooks/useCurrentUser";
import moment from "moment";

const SocialReachesSingle = ({ social, title, hasReached }) => {
  const [screens, setScreens] = useState([]);
  const [activeStage, setActiveStage] = useState(1);
  const { user } = useCurrentUser();
  const [dates, setDates] = useState(null);

  useEffect(() => {
    axios
      .get(`/screen?stage=${activeStage}&social=${social}`)
      .then((res) => {
        setScreens(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    const getDates = async () => {
      try {
        const res = await axios.get("/screen-dates");

        if (res.status !== 200) throw new Error("Can not get screen dates.");

        setDates(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    getDates();
  }, [social, activeStage]);

  return (
    <>
      <div className="card bg-base-100 shadow-xl">
        <div className="card-body">
          <h2 className="card-title">{title}</h2>

          <Tb selectedTabClassName="tab-active">
            <TabList>
              <Tab
                onClick={() => setActiveStage(1)}
                className={`tab tab-lg tab-lifted font-fira-go rounded ${
                  activeStage === 1 && "bg-gray-200"
                }`}
              >
                ეტაპი 1
              </Tab>
              {hasReached && (
                <Tab
                  onClick={() => setActiveStage(2)}
                  className={`tab tab-lg tab-lifted font-fira-go rounded ${
                    activeStage === 2 && "bg-gray-200"
                  }`}
                >
                  ეტაპი 2
                </Tab>
              )}
            </TabList>
            <TabPanel>
              <div className="flex flex-wrap gap-8">
                {screens.length > 0 ? (
                  screens
                    .filter((item) => item.stage === 1)
                    .map((item, i) => (
                      <SocialReachesSingleItem key={i} {...item} />
                    ))
                ) : (
                  <p>სქრინები არ არის ატვირთული</p>
                )}
              </div>
            </TabPanel>
            {hasReached && (
              <TabPanel>
                <div className="flex flex-wrap gap-8">
                  {screens.length > 0 ? (
                    screens
                      .filter((item) => item.stage === 2)
                      .map((item, i) => (
                        <SocialReachesSingleItem key={i} {...item} />
                      ))
                  ) : (
                    <p>სქრინები არ არის ატვირთული</p>
                  )}
                </div>
              </TabPanel>
            )}
          </Tb>

          {moment(dates?.end_date).isAfter(new Date()) ? (
            <div className="card-actions justify-end">
              {activeStage === 1 && user.stage === 2 ? (
                <a href={`#socModal_${social}`} className="btn" disabled>
                  დამატება
                </a>
              ) : (
                <a href={`#socModal_${social}`} className="btn">
                  დამატება
                </a>
              )}
            </div>
          ) : (
            <div className="alert alert-warning shadow">
              <p className="flex gap-2">
                <svg
                  width={20}
                  height={20}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
                </svg>
                სქრინების ატვირთვა დასრულდა.
              </p>
            </div>
          )}
        </div>
      </div>

      <div id={`socModal_${social}`} className="modal">
        <div className="modal-box">
          <div className="flex items-center justify-between">
            <h3 className="font-bold text-lg">{title}</h3>
            <a href="#" className="btn">
              X
            </a>
          </div>
          <AddScreenshots social={social} stage={activeStage} />
        </div>
      </div>
    </>
  );
};

export default SocialReachesSingle;
